import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import Loader from '@/components/loader';
import { authClient } from '@/lib/auth-client';

export const Route = createFileRoute('/')({
  component: HomeComponent,
});

function HomeComponent() {
  const { data: session, isPending } = authClient.useSession();
  const navigate = Route.useNavigate();

  useEffect(() => {
    if (!isPending) {
      if (session) {
        // Se está autenticado, vai para o dashboard
        navigate({ to: '/dashboard' });
      } else {
        // Se não está autenticado, vai para o login
        navigate({ to: '/login' });
      }
    }
  }, [session, isPending, navigate]);

  // Mostra loader enquanto verifica autenticação ou redireciona
  return <Loader />;
}
